import {Component} from 'react';



export class GlobalVariable extends Component <any, any> {
    constructor(props: any) {
        super(props);
        this.state = {

        };


    }
    static staffBack() {
        return process.env.REACT_APP_STAFF_API_URL || '';
    }

    static supportBack() {
        return process.env.REACT_APP_SUPPORT_API_URL || '';
    }


    static host() {
        return process.env.REACT_APP_LEGACY_API_URL || process.env.REACT_APP_SITE_API_URL || '';
    }

}
export default GlobalVariable;
